<template>
  <div :class="['suspend', pcNavFixedFlag && 'fixed']" v-show="show">
    <div class="m">
      <div>
        <a :href="`tel:${tel}`" class="tel"></a>
      </div>
      <div class="to-top" v-if="topIconFlag" @click="scrollTop"></div>
    </div>
    <div class="pc">
      <div>
        <span class="tel"></span>
      </div>
      <div class="to-top" v-if="topIconFlag" @click="scrollTop"></div>
    </div>
  </div>
</template>
<script>
import XHR from '../api'
export default {
  name: 'Suspend',
  props: {
    toTopClass: {
      type: String,
      default: ''
    },
    pcNavFixedFlag: {
      type: Boolean,
      default: true
    },
    topIconFlag: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tel: '',
    show: true,
    timer: '',
    isNewApp: false
  }),
  components: {},
  created () {
    // 获取客服电话号码
    XHR.getHandWork({
      type: 17,
      hid: 3862
    }).then(res => {
      const { status, data } = res.data
      if (!status) {
        this.tel = data[0].title
      }
    })
  },
  mounted () {},
  beforeDestroy () {},
  methods: {
    // 回到顶部
    scrollTop () {
      document.querySelector(this.toTopClass).scrollIntoView()
      this.$emit('returnScrollTop', 2)
    }
  }
}
</script>
<style lang="less" scoped>
.suspend {
  .m {
    display: block;
    height: 212px;
    z-index: 1000;
    position: fixed;
    right: 0px;
    bottom: 116px;
    .tel {
      background-image: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/m-kefu.png');
      width: 99px;
      height: 100px;
      display: block;
      margin-bottom: 12px;
    }
    .to-top {
      background-image: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/m-dingbu.png');
      width: 99px;
      height: 100px;
    }
  }
  .pc {
    display: none;
    .tel {
      background-image: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/pc-kefu.png');
      width: 168px;
      height: 98px;
      display: block;
      margin-bottom: 12px;
      cursor: pointer;
    }
    .to-top {
      background-image: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/pc-dingbu.png');
      width: 168px;
      height: 70px;
      cursor: pointer;
    }
  }
}
// pc
@media screen and (min-width: 751px) {
  .suspend .m {
    display: none;
  }
  .suspend {
    position: absolute;
    top: 800px;
    left: 50%;
    margin-left: 370px;
    z-index: 1000;
    transform: translate(0, -50%);
    right: 10px;
    display: flex;
    &.fixed {
      position: fixed;
      // top: 125px;
    }
  }
  .suspend .pc {
    display: block;
    height: 180px;
  }
}
@media screen and (max-width: 1060px) {
  .suspend {
    left: auto;
    margin-left: auto;
    right: 4px;
    z-index: 1000;
    &.fixed {
      position: fixed;
      left: auto;
      margin-left: auto;
      // top: 125px;
    }
  }
}
</style>
